import * as React from 'react';

import { ListItemText, SelectChangeEvent } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { VectorDown } from 'components/common/Icons/Icons';
import { InputSelectProps } from 'components/common/InputSelect/inputSelect.types';

import styles from './InputSelect.module.scss';

const InputSelect = ({
  items,
  onChange,
  disabled = false,
  currentValue,
  label,
  errorMessage,
  useRequiredSymbol,
}: InputSelectProps) => {
  const [isSelectOpen, setIsSelectOpen] = React.useState(false);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    onChange(event.target.value as string);
  };

  const handleClose = () => {
    setIsSelectOpen(false);
  };

  const handleOpen = () => {
    setIsSelectOpen(true);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.inputLabel}>
        {label}
        {useRequiredSymbol && <div className={styles.requiredLabel}>*</div>}
      </div>
      <Select
        variant="outlined"
        open={isSelectOpen}
        fullWidth
        sx={{
          height: '60px',
          '& .MuiSelect-select': {
            padding: '16px 20px',
            height: '60px',
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-select.Mui-disabled': {
            background: '#f4f5f6',
            WebkitTextFillColor: '#687a8c',
            height: '60px',
            boxSizing: 'border-box',
          },
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d0d5db',
          },
          '& .MuiTypography-root': {
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: 'normal',
            fontFamily: 'Poppins',
          },
          '& .MuiInputBase-input': {
            padding: '16px 20px',
          },
          '& .MuiInputBase-input.Mui-disabled': {
            background: '#f4f5f6',
            WebkitTextFillColor: '#687a8c',
            padding: '14px 20px',
          },
          '&.Mui-error': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: '2px solid red',
            },
          },
          '&.MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: '#808b96',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#2c3d50',
            },
          },
        }}
        classes={{
          icon: styles.selectIcon,
          iconOpen: styles.selectIconOpen,
        }}
        IconComponent={(props) => (disabled ? <></> : <VectorDown {...props} />)}
        MenuProps={{
          classes: {
            list: styles.menuList,
          },
        }}
        onChange={handleChange}
        onClose={handleClose}
        onOpen={handleOpen}
        disabled={disabled}
        value={(currentValue || '') as any}
        error={!!errorMessage}
      >
        {items.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            disabled={item.disabled}
            classes={{
              root: styles.menuItem,
              selected: styles.menuItemSelected,
              focusVisible: styles.menuItemFocusVisible,
            }}
          >
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Select>
      {!!errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
    </div>
  );
};

export default InputSelect;
